<template>
  <transition name="fade">
    <create-inline ref="createBox" v-bind="{post, update, comment, replyTo}" :isComment="true" @saved="created" @saving="saving" :context="'comment'" @cancel="$emit('cancel')" @delete="$emit('delete')" :isGrid="isGrid"></create-inline>
  </transition>
</template>

<script>
import CreateInline from '@/components/Forms/Create/Comment'

export default {
  components: {
    CreateInline
  },
  props: ['post', 'comment', 'update', 'scrollCheck', 'replyTo', 'isGrid'],
  watch: {
    scrollCheck: function () {
      if (this.scrollCheck > 0) {
        this.scrollTo()
      }
    }
  },
  methods: {
    created: function (comment) {
      this.$emit('created', comment)
    },
    saving: function (value) {
      this.$emit('saving', value)
    },
    scrollTo: function () {
      this.$refs.createBox.$el.scrollIntoView({ behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>

</style>
